import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createSgi, listSgis, sgiDashboard, updateSgi, type CreateSgiInput } from "./api";

const KEY = ["sgis"];

export const useSgis = () => useQuery({ queryKey: KEY, queryFn: listSgis });

export const useSgiDashboard = () =>
  useQuery({ queryKey: ["sgis", "dashboard"], queryFn: sgiDashboard });

export function useCreateSgi() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSgiInput) => createSgi(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateSgi() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: Partial<CreateSgiInput> & { active?: boolean } }) =>
      updateSgi(id, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
